import AssistantMessageRow from '../AssistantMessageRow'
import ChatThreadAssistantContent from './ChatThreadAssistantContent.jsx'
import ChatThreadAssistantPreamble from './ChatThreadAssistantPreamble.jsx'
import { assistantBlockState } from './assistantBlockState.js'
import { getAssistantPreambleToggle } from './getAssistantPreambleToggle.js'

export default function ChatThreadExchangeAssistantBlock({
  currentAssistant,
  ...props
}) {
  const state = assistantBlockState({ currentAssistant, ...props })
  if (state.isOpenAgentQuestion && !(currentAssistant.blocks?.length > 0))
    return null
  return (
    <AssistantMessageRow
      streaming={Boolean(currentAssistant.demoStreamActive)}
      messageId={currentAssistant.id}
      highlighted={props.focusedMessageId === currentAssistant.id}
    >
      <ChatThreadAssistantPreamble
        assistant={currentAssistant}
        expanded={Boolean(
          props.preambleExpandedByAssistantId[currentAssistant.id],
        )}
        onToggleExpand={getAssistantPreambleToggle(
          currentAssistant,
          props.togglePreambleExpanded,
        )}
      />
      <ChatThreadAssistantContent
        currentAssistant={currentAssistant}
        {...props}
        {...state}
      />
    </AssistantMessageRow>
  )
}
